import BaseService from '../base.service'
export class SiteConfigService extends BaseService {
  /**
   * The constructor for the ArtistService.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor (parameters = {}) {
    super('public/api/site/config', parameters)
  }
}